/**
 * Lightweight logger — emits to console only in development.
 * Prevents leaking internal errors to production users while keeping debug visibility locally.
 */

const isDev = process.env.NODE_ENV === "development";

export const logger = {
  error: (...args) => {
    if (isDev) console.error(...args);
  },
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  info: (...args) => {
    if (isDev) console.info(...args);
  },
};

export default logger;
